import { render, staticRenderFns } from "./DMS.vue?vue&type=template&id=1193e84a&"
import script from "./DMS.vue?vue&type=script&lang=js&"
export * from "./DMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports